import Vue from "vue";
import Home from "./Home.vue";
import App from "./App.vue";
import StripeView from "./StripeView.vue";
import vuetify from "./plugins/vuetify";
import * as firebase from "firebase";
import * as firebaseui from "firebaseui";
import VueRouter from "vue-router";

const firebaseConfig = {
  apiKey: "AIzaSyAuS16wzj2H-oV8nMcciPw4CvRvOmAzQHs",
  authDomain: "satplanner-a72a7.firebaseapp.com",
  databaseURL: "https://satplanner-a72a7.firebaseio.com",
  projectId: "satplanner-a72a7",
  storageBucket: "satplanner-a72a7.appspot.com",
  messagingSenderId: "737970683456",
  appId: "1:737970683456:web:ecc517dd638a42e377e9a5",
  measurementId: "G-XB9NPBM1LW",
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();

window.anon = () => {
  firebase
    .auth()
    .signInAnonymously()
    .catch(function(error) {
      console.log(error);
    });
};
// satplannerauth
// 737970683456-pkndbsvc37470uvnjdukn79u7nl92bae.apps.googleusercontent.com
// CV6BexRQBxGk-d3W0Ya3TRXR
const ui = new firebaseui.auth.AuthUI(firebase.auth());
// firebase.auth().signOut();

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    document.getElementById("intro").style.display = "none";
    Vue.config.productionTip = false;
    Vue.mixin({
      methods: {
        getUser() {
          const loggeUser = { ...user };
          window.user = loggeUser;
          if (user.isAnonymous) {
            loggeUser.email = `${user.uid}`;
          }
          return loggeUser;
        },
        async getToken() {
          const token = await firebase.auth().currentUser.getIdToken(false);
          window.token = token;
          return token;
        },
      },
    });
    Vue.use(VueRouter);

    const router = new VueRouter({
      // routes, // short for `routes: routes`
      routes: [
        { path: "/home", component: Home },
        { path: "/offers", component: StripeView },
        { path: "/boards/:id", component: App },
        {
          path: "*",
          component: Home,
        },
      ],
    });

    new Vue({
      vuetify,
      router,
      template: `
        <router-view></router-view>
      `,
    }).$mount("#app");
  } else {
    document.getElementById("intro").style.display = "block";
    document.getElementById("firebaseui-auth-container").style.display =
      "block";

    ui.start("#firebaseui-auth-container", {
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      signInSuccessUrl: `${document.location.origin}/#/home`,
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          console.log("auth ui cb", authResult, redirectUrl);
          return true;
        },
        uiShown: function() {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById("loader").style.display = "none";
        },
      },
    });
  }
});
